import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import { GUARANTEES_APPLICATION_FILES_LOADING_TEXT } from './constants.ts';

const ApplicationFilesLoading: React.FC = () => (
  <Box sx={guaranteesClientPageStyles.statusFlowLoading}>
    <CircularProgress size={18} />
    <Typography sx={guaranteesClientPageStyles.statusFlowLoadingText}>
      {GUARANTEES_APPLICATION_FILES_LOADING_TEXT}
    </Typography>
  </Box>
);

export default ApplicationFilesLoading;
